<template>
  <div id="maincont" :class="[{'collapsed' : collapsed}, {'onmobile' : isOnMobile}]">
    <sidebar-menu :menu="visibleitems" theme="white-theme" :collapsed="collapsed"
                  :show-one-child="true" @toggle-collapse="onToggleCollapse" width-collapsed="50px"
                  @item-click="onItemClick" class="border-right" v-show="(!isOnMobile) || (!collapsed)">
      <template v-slot:header>
        <b-navbar type="dark" variant="info" size="sm" class="pl-2">
          <b-navbar-brand href="#/"><img width="30" height="30" class="d-inline-block align-top bg-white rounded-circle"
                                         alt="logo"
                                         :src="require('@/assets/logo.png')"/></b-navbar-brand>
          <b-navbar-brand v-if="!collapsed" href="#/"><strong>SIE</strong> Portal
          </b-navbar-brand>
        </b-navbar>
      </template>
      <template v-slot:toggle-icon>
        <b-icon :icon="!collapsed?'chevron-double-left':'chevron-double-right'"/>
      </template>
      <template v-slot:dropdown-icon="{ isOpen }">
        <span v-if="!isOpen">+</span>
        <span v-else>-</span>
      </template>
    </sidebar-menu>
    <div
        v-if="isOnMobile && !collapsed"
        class="sidebar-overlay"
        @click="collapsed = true"
    />
    <div>
      <TemplateHeader :collapsed="collapsed" :is-on-mobile="isOnMobile" @burghertoggle="collapsed = !collapsed"/>
      <router-view class="px-3"/>
    </div>
  </div>
</template>

<script>
import TemplateHeader from "@/components/interface/TemplateHeader.vue";
import {SidebarMenu} from 'vue-sidebar-menu'
import "vue-sidebar-menu/dist/vue-sidebar-menu.css"
import {mapGetters} from "vuex";


export default {
  name: "DefaultView",
  components: {SidebarMenu, TemplateHeader},
  data() {
    return {
      collapsed: false,
      isOnMobile: false,
    }
  },
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
  },
  computed: {
    ...mapGetters("menu", ["visibleitems"])
  },

  methods: {
    onToggleCollapse(collapsed) {
      console.log(collapsed)
      this.collapsed = collapsed
    },
    onItemClick(event, item, node) {
      console.log('onItemClick', event, item, node)
      if (item?.href?.name === 'report') {
        this.$router.push({name: "goreport", params: item.href.params})
      } else {
        this.$router.push(item.href).catch(() => {
        })
      }
      event.preventDefault()
    },
    onResize() {
      this.collapsed = window.innerWidth <= 900;
      this.isOnMobile = window.innerWidth <= 700;
    }
  }
}
</script>

<style>


</style>